import { Select } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import { IInvoiceNo, IInvoiceNoReq, IInvoiceNoRes } from '@/interfaces/misc';
import { AxiosResponse } from 'axios';
import { searchInvoiceNo } from '@/adapters/misc';
import { useEffect, useState } from 'react';

interface IProps {
  disabled?: boolean;
  value?: string;
  invoiceNo?: IInvoiceNo;
  size?: SizeType;
  isAll?: boolean;
  handleSelectData: (invoiceNo: IInvoiceNo) => void;
  readonly?: boolean;
  customClass?: string;
  allowClear?: boolean;
  dateFrom?: string;
  dateTo?: string;
  invoiceType?: string;
}

const _criteria: IInvoiceNoReq = {
  dateFrom: undefined,
  dateTo: undefined,
  invoiceType: 'INV',
};

const InvoiceNoSelector = ({
  disabled = false,
  value,
  size = 'large',
  handleSelectData,
  isAll = false,
  readonly = false,
  invoiceNo,
  customClass,
  allowClear = true,
  dateFrom,
  dateTo,
  invoiceType,
}: IProps) => {
  const [criteria, setCriteria] = useState<IInvoiceNoReq>({
    ..._criteria,
    dateFrom,
    dateTo,
    invoiceType,
  });

  useEffect(() => {
    setCriteria((prev) => ({
      ...prev,
      dateFrom,
      dateTo,
      invoiceType,
    }));
  }, [dateFrom, dateTo, invoiceType]);

  const { data: invoiceNos, isLoading } = useQuery<
    AxiosResponse<IInvoiceNoRes>,
    Error
  >({
    queryKey: ['search-invoice-no', criteria],
    queryFn: async () => await searchInvoiceNo(criteria),
  });

  let groupOptions =
    invoiceNos?.data?.data?.map((g) => {
      return {
        value: `${g.ID}`,
        label: `${g.ID}`,
      };
    }) || [];

  const allOptions = [{ value: '', label: 'ทั้งหมด' }, ...groupOptions];

  const onChange = (value: string) => {
    const invoiceNoInfo = invoiceNos?.data?.data?.find((d) => d.ID === value);
    handleSelectData(invoiceNoInfo as IInvoiceNo);
  };

  if (invoiceNo) groupOptions = [...groupOptions];
  return (
    <Select
      allowClear={allowClear}
      showSearch
      loading={isLoading}
      value={value}
      className={customClass}
      size={size}
      placeholder="เลือกเลขที่ใบกำกับภาษี"
      onChange={(value) => onChange(value)}
      onClear={() => onChange('')}
      options={isAll ? allOptions : [...groupOptions]}
      filterOption={(input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
      }
      disabled={readonly || isLoading || disabled}
    />
  );
};

export default InvoiceNoSelector;
